<template>
	<div class="px-5">
		<app-table
			class="mt-5"
			:check-all="checkAll"
			:current-page="currentPage"
			:last-page="lastPage"
			:items-quantity="rows.length"
			:items-total-quantity="totalQuantity"
			selectable
			name="accounting-accounts"
			:columns="columns"
			:rows="rows"
			@on-selected-all="$emit('on-selected-all', $event)"
			@on-page="$emit('on-page', $event)"
			@on-search-event="onSearch"
			@row-is-selected="$emit('row-is-selected', $event)"
		>
			<template slot="rows" slot-scope="props">
				<td>{{ props.row.account }}</td>
				<td>{{ props.row.name }}</td>
				<td>{{ props.row.code }}</td>
				<td>{{ props.row.fatherAccount === "undefined" ? '' :  props.row.fatherAccount}}</td>
				<!--<td class="stat">
					<v-checkbox
						class=" ma-0 justify-center check-table"
						color="success"
						hide-details
						v-model="props.row.stat"
					></v-checkbox>
				</td>-->
				<td>{{ props.row.status === 0 ? 'Cuenta Grupo' : 'Cuenta Movimiento' }}</td>
				<td>{{ props.row.auxCont === 0 ? 'No' : 'Si' }}</td>
				<td @click.stop="stopClick">
					<app-tooltip-button
						class="no-movil"
						color="success"
						icon="edit"
						text="Editar Cuenta"
						@click-icon="$emit('edit', props.row)"
					/>
					<app-tooltip-button
						class="no-movil"
						color="error"
						icon="delete"
						text="Eliminar Cuenta"
						@click-icon="$emit('on-delete', props.row)"
					/>
				</td>
				<div
					class="collapse-menu"
					>
	<v-menu>
		<v-btn dark icon slot="activator">
			<v-icon>more_horiz</v-icon>
		</v-btn>
		<v-list>
			<v-list-tile class="btn-menu-content">
				<v-list-tile-title class="menu-content" @click="$emit('edit', props.row)">
					<img
						src="/static/img/actions-list/edit.svg"
						alt="icono"
						class="menu-option-icon"
						width="15px"
						height="15px"
					>
					<span class="ml-1 edit">Editar</span>
				</v-list-tile-title>
			</v-list-tile>
			<v-list-tile>
				<v-list-tile-title class="menu-content" @click="$emit('on-delete', props.row)">
					<img
						src="/static/img/actions-list/delete.svg"
						alt="icono"
						class="menu-option-icon"
						width="15px"
						height="15px"
					>
					<span class="ml-1">Eliminar</span>
				</v-list-tile-title>
			</v-list-tile>
		</v-list>
	</v-menu>
</div>
			</template>
		</app-table>
	</div>
</template>

<script>
import appTooltipButton from '@/components/shared/app-tooltip-button';

function onSearch(value) {
	this.$emit('on-search', value);
}

export default {
	name: 'accounting-account-list',
	components: {
		appTooltipButton,
	},
	methods: {
		onSearch,
	},
	props: {
		checkAll: {
			default: false,
			type: Boolean,
		},
		columns: {
			type: Array,
			required: true,
		},
		currentPage: {
			type: Number,
			default: 1,
		},
		lastPage: {
			type: Number,
			default: 0,
		},
		rows: {
			type: Array,
			required: true,
		},
		totalQuantity: {
			type: Number,
		},
	},
};
</script>
<style scoped lang="scss">
.collapse-menu {
	display: none;
	@media (max-width: 768px) {
		align-items: center;
		display: block;
		grid-column: 7/7;
		grid-row: 1;
		height: 100%;
		justify-content: center;
		.v-menu {
			align-items: center;
			display: flex;
			height: 100%;
			justify-content: center;
			.v-btn {
				background-color: color(btn-green);
				height: 25px;
				margin: 0;
				width: 25px;
			}
		}
	}
}
.btn-menu-content {
	border-bottom: 1px solid color(grey-background-table);
}
.menu-content {
	align-items: center;
	color: color(red-icon);
	display: grid;
	font-family: font(AvenirRegular);
	font-size: size(small) !important;
	grid-column-gap: 3px;
	grid-template-columns: 15px 1fr;
	width: 175px;
	.factory {
		color: color(secondary);
	}
	.edit {
		color: color(btn-green);
	}
}
.stat {
	@media (max-width: 768px) {
		display: grid;
		grid-column: 6/6;
		grid-row: 1;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/accounting-accounts/accounting-account-list.vue